export default "__VITE_ASSET__ByNq6sLo__"